import axios from 'axios';

const adminUrl = process.env.VUE_APP_ADMIN_URL;

export default class ContractProfitabilityService {
  /**
   * Obtiene la rentabilidad por contrato (ingresos, costos, margen, siniestralidad) para el rango de
   * fechas indicado (por defecto, los últimos 12 meses).
   * @param {string} countryId - UUID del país (obligatorio).
   * @param {string[]} lineasNegocio - Líneas de negocio a incluir (repetidas como query param).
   * @param {string} [from] - Fecha de inicio (YYYY-MM-DD), inclusive.
   * @param {string} [to] - Fecha de fin (YYYY-MM-DD), inclusive.
   * @param {string[]} [statuses] - Estados de contrato a incluir ('Activo' | 'Churned' | 'Pausado');
   *   si se omite, el backend sólo devuelve contratos activos.
   * @returns {Promise<{status: string, data?: object}>}
   */
  static async getContractProfitability(countryId, lineasNegocio = [], from, to, statuses = []) {
    try {
      const accessToken = JSON.parse(localStorage.getItem('accessToken'));
      const params = new URLSearchParams();
      params.append('countryId', countryId);
      lineasNegocio.forEach(linea => params.append('lineaNegocio', linea));
      statuses.forEach(status => params.append('status', status));
      if (from) params.append('from', from);
      if (to) params.append('to', to);

      const response = await axios.get(`${adminUrl}/contract-profitability?${params.toString()}`, {
        headers: { Authorization: `Bearer ${accessToken}` }
      });

      if (response.data.status === 'ok') {
        return { status: 'ok', data: response.data.data };
      }
      return { status: 'error' };
    } catch (error) {
      return { status: 'error' };
    }
  }
}
